import { useEffect } from 'react';
import { useAppStore } from '../store/appStore';
import { darkTheme, lightTheme } from './tokens';

function resolveTheme(setting: 'light' | 'dark' | 'system'): 'light' | 'dark' {
  if (setting === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return setting;
}

/**
 * Syncs CSS custom properties to the active theme so plain CSS rules
 * (e.g. the html/body background that prevents route-transition flash)
 * stay in step with the in-app theme — including 'system' tracking the OS.
 */
export function ThemeSync() {
  const themeSetting = useAppStore((s) => s.theme);

  useEffect(() => {
    const apply = () => {
      const resolved = resolveTheme(themeSetting);
      // Named `palette` (not `tokens`) to avoid confusion with the auth-tokens
      // helper exported from api/client.ts.
      const palette = resolved === 'dark' ? darkTheme : lightTheme;
      document.documentElement.style.setProperty('--bg', palette.bg);
    };

    apply();

    if (themeSetting === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [themeSetting]);

  return null;
}
